import { useEffect, useRef, useState } from "react";
import PlayerCard from "../playerCard/playerCard";
import PlayListCard from "../playList/playListCard";
import { handleGetTags, handleSearchResultClick } from "../../../../../redux/actions/tags.actions";
import useIntersect from "../../../../../helpers/hooks/useIntersect";
import { conditions } from "../../../../../helpers";
import { ConditionName, ISelectedTagsVideoListProps } from "../../../../../interfaces";

const SelectedTagsVideoList = ({ listScrolled, setListScrolled, videoCount }: ISelectedTagsVideoListProps) => {
    const [scrollEnd, setScrollEnd] = useState(false);
    const videoCountRef = useRef<number>(videoCount);
    const listScrolledRef = useRef<any[]>(listScrolled);
    const playListCardInfoRef = useRef<any>({});

    useEffect(() => {
        videoCountRef.current = videoCount;
    }, [videoCount]);

    useEffect(() => {
        listScrolledRef.current = listScrolled;
    }, [listScrolled]);

    useEffect(() => handleGetTags(scrollEnd, setScrollEnd, listScrolled, setListScrolled), [scrollEnd]);

    const handleIntersect = ([entry]: IntersectionObserverEntry[]) => {
        if (entry.isIntersecting && listScrolledRef.current.length !== videoCountRef.current) setScrollEnd(true);
    };

    const observerRef = useIntersect(handleIntersect);

    return (
        <div>
            <div
                className={`pl-flex pl-flex-wrap ${
                    conditions(ConditionName.isComplexPortrait) ? "pl-gap-2 pl-mb-[300px] pl-flex-col" : "pl-gap-[17px]"
                } pl-mx-3`}
            >
                {listScrolled.map((item: any, index: number) => {
                    return (
                        <div
                            key={item.video.id}
                            id={`tagVideoList-${item.video.id}`}
                            className={`${
                                !conditions(ConditionName.isComplexPortrait) && "pl-grow"
                            } pl-relative pl-cursor-pointer pl-overflow-hidden`}
                            style={{
                                width: conditions(ConditionName.isComplexPortrait) ? "100%" : 265,
                                height: conditions(ConditionName.isComplexPortrait) ? 88 : "initial"
                            }}
                        >
                            <PlayerCard
                                id={item.video.id}
                                tags={item.video.tag}
                                isTagCard={!conditions(ConditionName.isComplexPortrait)}
                                src={item.video.banner}
                                type={item.video.type}
                                imdb_rate={item.video.imdb_rate}
                                isVideo={false}
                                width={conditions(ConditionName.isComplexPortrait) ? 156 : "unset"}
                                height={conditions(ConditionName.isComplexPortrait) ? 88 : 149}
                                duration={item.video.duration}
                                title={item.video.title}
                                isComplexDesktop={conditions(ConditionName.isComplexDesktop)}
                                viewers={item.video.viewers}
                                date={item.video.type === "playlist" ? item.video.release_year : item.video.start_time}
                                onClick={(event: any) =>
                                    handleSearchResultClick(event, item.video, playListCardInfoRef, item.video.id, item.video.type, index)
                                }
                                commentsCount={item.video.comments_count}
                                star={item.video.star}
                            />
                        </div>
                    );
                })}
                {((scrollEnd && listScrolled.length !== videoCount) || conditions(ConditionName.isComplexDesktop)) &&
                    Array.from(Array(conditions(ConditionName.isComplexPortrait) ? 20 : 10).keys()).map((item, i) => (
                        <div
                            key={i}
                            className={`${
                                scrollEnd && listScrolled.length !== videoCount && "pl-shadow"
                            } animate-pulse pl-flex pl-overflow-hidden pl-h-full ${
                                conditions(ConditionName.isComplexPortrait) ? "pl-flex-row pl-gap-2 pl-items-start" : "pl-flex-col pl-grow"
                            }`}
                            style={{
                                height: conditions(ConditionName.isComplexPortrait) ? 80 : "initial",
                                width: conditions(ConditionName.isComplexPortrait) ? "initial" : 265
                            }}
                        >
                            <div
                                className={`${
                                    conditions(ConditionName.isComplexPortrait)
                                        ? scrollEnd && listScrolled.length !== videoCount
                                            ? "pl-relative pl-flex-none pl-bg-gray-100 dark:pl-bg-secondary-600 pl-w-[142px] pl-h-[80px]"
                                            : "pl-w-[142px] pl-h-full"
                                        : scrollEnd &&
                                          listScrolled.length !== videoCount &&
                                          "pl-bg-gray-100 dark:pl-bg-secondary-600 pl-w-full !pl-aspect-video"
                                }`}
                            />
                            <div className={`pl-flex pl-py-1 pl-w-full pl-h-full pl-flex-col pl-gap-0.5 pl-justify-around pl-overflow-hidden`}>
                                <div
                                    className={`${
                                        scrollEnd && listScrolled.length !== videoCount ? "pl-bg-gray-200 dark:pl-bg-z-gray-700" : ""
                                    } pl-h-2.5 pl-rounded-full pl-w-48 pl-mb-4`}
                                />
                                <div className="pl-flex pl-flex-col pl-items-end pl-gap-2">
                                    <div
                                        className={`pl-h-2.5 ${
                                            scrollEnd && listScrolled.length !== videoCount ? "pl-bg-gray-200 dark:pl-bg-z-gray-700" : ""
                                        } pl-rounded-full pl-w-full`}
                                    />
                                    <div
                                        className={`pl-h-2 ${
                                            scrollEnd && listScrolled.length !== videoCount ? "pl-bg-gray-200 dark:pl-bg-z-gray-700" : ""
                                        } pl-rounded-full pl-w-full`}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                {conditions(ConditionName.isComplexPortrait) && <div id="observer" className="pl-bg-transparent pl-pt-5" ref={observerRef} />}
            </div>
            {!conditions(ConditionName.isComplexPortrait) && <div id="observer" className="pl-bg-transparent pl-pt-5" ref={observerRef} />}
            <PlayListCard playListCardInfo={playListCardInfoRef.current} />
        </div>
    );
};

export default SelectedTagsVideoList;
